module.exports = __webpack_public_path__ + "static/media/ma.581173bd.svg";